<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(false);
  pagingStore.showNext(true);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(false);
  laraStore.setCoords({ x: 400, y: window.innerHeight / 2 - 200 });
  laraStore.setOpacity(1);

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("white");
  stylesColor.set("black");
</script>

<style>
.intro {
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply w-full;
  @apply h-full;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 20%,  rgba(0, 0, 0, 0.05) 48%, #ffffff 50%);
    background-size: 200% 100%;
    background-position: 0% 100%;

    animation: shadow 1.2s ease-in-out;
    animation-delay: 0.2s;
    animation-fill-mode: forwards;
}

@keyframes shadow {
  from { background-position: 0% 100%; }
  to { background-position: 100% 100%; }
}
</style>

<div class="intro">
  <Quote title="Der Aufbruch">
    Es war zu einer Zeit, als auf der Erde die Umstände wiederwärtig wurden.
    Eine tapfere Schar Kreativer machte sich auf mit dem hehren Ziel, ihr ganz
    eigenes Paradies zu finden.
  </Quote>
</div>
